module.exports = __webpack_public_path__ + "static/media/icon-house.955af646.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/lecture/icon-house.png
// module id = 1930
// module chunks = 6